'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _request = require('../request');

var _request2 = _interopRequireDefault(_request);

var _keeper = require('../keeper');

var _keeper2 = _interopRequireDefault(_keeper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Promise = window.Promise || require('promise');

var DPcity = function () {
    function DPcity() {
        _classCallCheck(this, DPcity);

        this.cityType = 'dianping';
        this.GEOTYPE = ['wgs84', 'gcj02']; // map coordType: 1, 2
        this.keeper = undefined;
    }

    _createClass(DPcity, [{
        key: 'process',
        value: function process() {
            var _this = this;

            var position = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
            var opt = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

            // TODO: 城市超时缓存，目前被`promise`直接丢弃了
            return new Promise(function (resolve, reject) {
                // 说明：若超时未开启，最差情况：无thenable对象返回，不影响业务整体超时失败，只丢掉一次城市API失败上报
                opt.trigger = function (token) {
                    reject({
                        // code: 408,
                        message: _this.cityType + ' city API Timeout: ' + opt.timeout + 'ms',
                        type: _this.type
                    });
                };
                _this.keeper = new _keeper2.default(opt);

                (0, _request2.default)({
                    url: "//mapi.dianping.com/getlocalcityid",
                    data: {
                        lat: position.lat,
                        lng: position.lng,
                        coordType: _this.GEOTYPE.indexOf(position.geoType.toLowerCase()) + 1 || 1
                    },
                    onSuc: function onSuc() {
                        var res = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

                        if (res.code == 200 && res.message) {
                            res.message.cityType = _this.cityType;
                            resolve(res.message);
                        } else {
                            reject({
                                message: _this.cityType + ' city API: fail'
                            });
                        }
                    }
                });
            });
        }
    }]);

    return DPcity;
}();

var instance = new DPcity();
module.exports = instance.process.bind(instance);


//////////////////
// WEBPACK FOOTER
// ./~/@dp/whereami/lib/city/dp.js
// module id = 357
// module chunks = 0